













import {
  defineComponent,
  getCurrentInstance,
  onUnmounted,
  onMounted,
  ref,
  computed,
  watch,
} from '@vue/composition-api';
import SpacePage from '@/renderer/components/SpacePage/list.vue';
import InviteMembers from '@/renderer/views/desktop/FileManagement/CollaborationSpace/components/InviteMembers.vue';

import store from '@/renderer/store';
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { CollaborateGroupEvents } from '@/renderer/store/modules/collaborateGroup';
import { useDrawer } from '@/renderer/views/desktop/FileManagement/CollaborationSpace/compositions/useDrawer';

export default defineComponent({
  components: {
    SpacePage,
    InviteMembers,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { query } = vm.$route;
    const spaceId = query.spaceId as string;
    const id = +query.id;
    const name = query.name as string;
    const spaceOrgId = +(query.spaceOrgId || query.orgId);

    const isShowMemberManage = ref(true);
    const { methods: drawerMethods, groupSelected } = useDrawer(spaceId, isShowMemberManage);

    const isExternal = computed(() => {
      if (query.isExternal) {
        return Boolean(query.isExternal);
      }
      // 兜底处理，避免groupSelected为undefined，页面出现空白
      return groupSelected.value?.isExternal || false;
    });

    const getGroupInfo = async (groupId: number) => {
      try {
        const { data } = await smh.userAPI.getGroupSpace({ groupId, spaceOrgId });
        // 获取到群组的空间，然后存进store
        store.commit('SET_GROUP_SPACE_QUOTA', data.availableSpace);
      } catch (error: MsgError) {
        tips.error(error);
      }
    };

    const showInviteDialog = ref(false);
    const openInviteDialog = () => {
      showInviteDialog.value = true;
    };

    const methods = {
      showMemberManage: (isShow: boolean) => {
        isShowMemberManage.value = isShow;
      },
    };

    watch(isShowMemberManage, (val: any) => {
      drawerMethods.setDrawers();
    });

    onMounted(() => {
      drawerMethods.setDrawers();
      // 进来页面还需要查询一下群组的各个信息
      vm.$store.dispatch(CollaborateGroupEvents.GET_GROUP_INFO, {
        id,
        spaceOrgId,
      });
      getGroupInfo(id);
    });
    onUnmounted(() => {
      vm.$store.commit(CollaborateGroupEvents.CLEAR_DATA);
    });

    return {
      spaceId,
      id,
      name,
      showInviteDialog,
      openInviteDialog,
      ...methods,
      groupSelected,
      isExternal,
    };
  },
});
